import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-setting-dialog',
  templateUrl: './remove-setting-dialog.component.html',
  styleUrls: ['./remove-setting-dialog.component.scss']
})
export class RemoveSettingDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveSettingDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      name: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
